<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">
            <mat-icon>security</mat-icon>
            <div>Ověření identity</div>
        </div>

        <button (click)="close()" type="button" [attr.data-testid]="'bankid-dialog-button-close'">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <form [formGroup]="form" [attr.data-testid]="'bankid-dialog'" class="hypo-dialog-content">
        <app-hypo-radio
            [label]="'Způsob ověření'"
            [showingList]="[
                { label: 'Bank iD', value: 'bankid' },
                { label: 'Kurýrní služba', value: 'courier' },
            ]"
            formControlName="verifiedBy">
        </app-hypo-radio>

        @if (form.get('verifiedBy').value === BankIdVerifiedByEnum.bankid) {
            <div class="flex flex-col gap-2">
                <div>
                    <p>
                        Vyberte banku, u které máte zřízenou bankovní identitu. Následně se Vám otevře v novém okně
                        stránka vybrané bankovní společnosti. Po ověření identity můžete tuto nově otevřenou záložku
                        zavřít, případně se nechat přesměrovat nazpět.
                    </p>
                </div>
                @if (isLoading) {
                    <div class="banks-loader flex flex-row items-center justify-center gap-4">
                        <div>Načítám seznam bank...</div>
                        <mat-spinner diameter="30"></mat-spinner>
                    </div>
                }
                @if (!isLoading) {
                    <section class="pt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
                        @for (provider of bankIdBanks; track provider) {
                            <div
                                (click)="authorizeByBankId(provider.bankId)"
                                [class.locked]="isVerified()"
                                class="bankid-item flex justify-center items-center"
                                [attr.data-testid]="'bankid-item-' + provider.stringCode">
                                @if (provider.stringCode) {
                                    <img [src]="'/assets/providers/' + provider.stringCode + '.png'" alt="" />
                                }
                                @if (!provider.bankId.available_logo_images?.length) {
                                    @if (provider.bankId.title) {
                                        {{
                                            provider.bankId.title.length > 50
                                                ? (provider.bankId.title | slice: 0 : 50) + '...'
                                                : provider.bankId.title
                                        }}
                                    }
                                }
                            </div>
                        }
                    </section>
                }
            </div>
        }
        @if (form.get('verifiedBy').value === BankIdVerifiedByEnum.courier) {
            <div>
                <div><p>Pro ověření Vaší identity za Vámi pošleme našeho kurýra.</p></div>
            </div>
        }
    </form>

    <div class="hypo-dialog-footer flex flex-row items-center justify-center">
        <button
            (click)="save()"
            class="btn btn-lg orange bankid-dialog-button-save"
            mat-button
            type="button"
            [attr.data-testid]="'bankid-dialog-button-continue'">
            Pokračovat
        </button>
    </div>
</mat-dialog-content>
